import { useCallback, useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/form/Select';
import timezoneOptions from '@/data/timezones';
import useUserTimezone from '@/hooks/useUserTimezone';
import { setTimezone } from '@/store/profile/index';
import { updateUser } from '@/store/profile/thunks';
import { capitalize, showError, showSuccess } from '@/utils';

import SectionForm from '../SectionForm';

function Timezone({ title, description }) {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const selectedTimezone = useUserTimezone();

	const validationSchema = Yup.object({
		timezone: Yup.string().required()
	});

	const methods = useForm({
		resolver: yupResolver(validationSchema),
		defaultValues: {
			timezone: selectedTimezone.value
		},
		mode: 'onChange'
	});

	const onSubmit = useCallback(async function (values) {
		setLoading(true);
		dispatch(
			updateUser({
				timezone: values.timezone
			})
		)
			.unwrap()
			.then(() => {
				dispatch(setTimezone(values.timezone));
				setLoading(false);
				showSuccess(t('account.toast'));
			})
			.catch(error => {
				showError(error);
				setLoading(false);
			});
	}, []);

	return (
		<SectionForm
			title={title}
			description={description}
			methods={methods}
			onSubmit={onSubmit}
			loading={loading}
		>
			<div className="m-0 flex w-full flex-col items-center">
				<div className="flex w-full flex-col gap-x-5 gap-y-4 lg:gap-y-6">
					<Select label={`${t('account.form.timezone')}`} name="timezone">
						<SelectTrigger
							className="group border-gray-200 bg-white p-0 text-grey-500 group-hover:text-grey-500"
							aria-label={t('account.form.timezone')}
						>
							<SelectValue />
						</SelectTrigger>
						<SelectContent className="border border-grey-200 bg-white">
							{timezoneOptions.map(({ value, label }, index) => {
								return (
									<SelectItem key={index} value={value}>
										{capitalize(label)}
									</SelectItem>
								);
							})}
						</SelectContent>
					</Select>
				</div>
			</div>
		</SectionForm>
	);
}

export default Timezone;
